import Scroller from 'vux/src/components/scroller/index.vue'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}
export default {
name: 'case',
components:{
Scroller
},
data () {
return {
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
classifyList:'',
classify:'',
productType:'',
page:1,
caseList:[],
caseBannerText:'',
activeItem:0,
banerImg:require('../../assets/images/modelingCaseBanner.png'),
}
},
watch: {
$route (to, from) {
if(this.$utils('type')=='design') {
this.classify = '3D建模'
this.caseBannerText = '了解3D建模在各个行业的应用'
this.banerImg = require('../../assets/images/modelingCaseBanner.png')
}else if(this.$utils('type')=='print') {
this.classify = '3D打印'
this.caseBannerText = '了解3D打印在各个行业的应用'
this.banerImg = require('../../assets/images/modelingCaseBanner.png')
}else if(this.$utils('type')=='software') {
this.classify = '3D小软件'
this.caseBannerText = ''
this.banerImg = require('../../assets/images/caseSoftwareBanner.png')
}
}
},
methods: {
getClassify(){
this.$request.post('/industryCase/getTypeByClassify',{
classify:this.classify,
}).then((res)=>{
if(res.code ==0) {
this.classifyList = res.obj

this.productType = res.obj[0].dictValue
this.loadMore()
}else{
this.$vux.toast.show({
type: 'warn',
text: res.msg
})
}
})
},
getCaseList(cb){
this.$request.post('/industryCase/listIndustryCase',{
classify:this.classify,
page:this.page,
rows:6,
productType:this.productType,
}).then((res)=>{
if(res.code ==0) {
cb(res.obj.rows)
}else{
this.$vux.toast.show({
type: 'warn',
text: res.msg
})
}
})
},
refresh() {
this.page = 1
this.getCaseList(data => {
this.caseList = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 6) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
})
this.page += 1
},
loadMore() {
this.getCaseList(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 6) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.caseList = this.caseList.concat(data)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},
gotoCaseInfo(id){
this.$router.push({
path:'./caseInfo',
query:{
id:id,
}
})
},
caseTypeClick(productType,index){
this.activeItem==index?this.activeItem=-1:this.activeItem=index
this.productType = productType
this.page = 1
this.getCaseList(data => {
this.caseList = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 6) {
this.$refs.scrollerBottom.disablePullup()
}
})
this.page += 1
},
},
computed: {

},
created() {
console.log(this.$utils('type'));
if(this.$utils('type')=='design') {
this.classify = '3D建模'
this.caseBannerText = '了解3D建模在各个行业的应用'
this.banerImg = require('../../assets/images/../../assets/images/modelingCaseBanner.png')
}else if(this.$utils('type')=='print') {
this.classify = '3D打印'
this.caseBannerText = '了解3D打印在各个行业的应用'
this.banerImg = require('../../assets/images/../../assets/images/modelingCaseBanner.png')
}else if(this.$utils('type')=='software') {
this.classify = '3D小软件'
this.caseBannerText = ''
this.banerImg = require('../../assets/images/../../assets/images/caseSoftwareBanner.png')
}
this.getClassify()
},
mounted() {

},
}


// WEBPACK FOOTER //
// ./src/views/case/script.js